let filestack, client;
export default async function filestackClient() {
  if (client) return client;
  if (!filestack) filestack = await import('filestack-js');
  client = filestack.init(process.env.FILESTACK_KEY);
  return client;
}



// WEBPACK FOOTER //
// ./src/lib/filestackClient.js